const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.DIET_DAYS)

export const apiDietDays = {
	fetchDietMenuCalendar: async (diet_id?: number): Promise<IDietMenuCalendarModel> => {
		const { data } = await apiCommon<IDietMenuCalendar>(`${groupPrefix}/calendar`, {
			method: 'GET',
			params: { diet_id },
		})

		return DietMenuCalendar(data)
	},

	fetchDietMenu: async (date: string, diet_id?: number | null): Promise<IDietMenuModel | null> => {
		const { data } = await apiCommon<IDietMenu>(`${groupPrefix}/for-diet`, {
			method: 'GET',
			params: { date, diet_id },
		})

		if (!data) return null

		return DietMenu(data)
	},

	createOrUpdateDietMenu: async (payload: IDietMenuPayloadModel): Promise<IDietMenuModel> => {
		const { data } = await apiCommon<IDietMenu>(`${groupPrefix}`, {
			method: 'POST',
			body: dietMenuPayloadToJSON(payload),
		})

		return DietMenu(data)
	},

	fetchDietMenuEditHistory: async (dietDayID: number, page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IDietMealEditHistory[]>(`${groupPrefix}/${dietDayID}/edit-history`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(d => DietMealEditHistory(d)), meta }
	},

	fetchDietMenuEditableStatus: async (date: string, dietID: number | undefined) => {
		const response = await apiCommon<any>(`${groupPrefix}/for-diet/edit`, {
			method: 'POST',
			params: { date, diet_id: dietID },
		})
		return { isLocked: response.is_locked }
	},

	unlockDietMenuEditableStatus: async (date: string, dietID: number) => {
		const { data } = await apiCommon<boolean>(`${groupPrefix}/for-diet/unlock`, {
			method: 'POST',
			params: { date, diet_id: dietID },
		})
		return data
	},
}
